"use client"
import { MapPin } from "lucide-react"
import { Card, CardContent, CardHeader, CardTitle } from "../ui/card"
import { Button } from "../ui/button"
import { Badge } from "../ui/badge"
import type { OrganizationProfile, User } from "@/server/db/schemas/auth"
import type { Job } from "@/server/db/schemas/job"
import { useTranslations } from "next-intl"
import Link from "next/link"

type Props = {
	job: {
		job: Job
		organization: OrganizationProfile
		user: User
	}
}

export default function JobListing({ job }: Props) {
	const t = useTranslations("home.jobListing")
	const jobsT = useTranslations("home.jobs.details.status")
	const enums = useTranslations("cities")

	return (
		<Card className="hover:shadow-md gap-2 transition-all duration-300 border flex flex-col h-full">
			<CardHeader>
				<div className="flex items-start justify-between gap-2 mb-3">
					<CardTitle className="text-lg font-semibold text-gray-900 break-words flex-1">
						{job.job.title}
					</CardTitle>
					{job.job.status === "done" && (
						<Badge variant="default" className="shrink-0">
							{jobsT("done")}
						</Badge>
					)}
				</div>

				<div className="flex items-center gap-1 text-gray-600 text-sm font-medium">
					<MapPin className="h-3 w-3" />
					<span>
						{enums(job.user.city)}
						{job.user.neighborhood && ` - ${job.user.neighborhood}`}
					</span>
				</div>
			</CardHeader>

			<CardContent className="flex-1 flex flex-col">
				<div className="text-gray-700 text-sm leading-relaxed whitespace-pre-wrap break-words line-clamp-4 mb-4">
					{job.job.description}
				</div>

				<Button asChild className="mt-auto w-fit ms-auto">
					<Link href={`/jobs/${job.job.id}`}>
						{t("buttons.viewJob")}
					</Link>
				</Button>
			</CardContent>
		</Card>
	)
}
